if (!customElements.get('h2o-product-availability')) {
  class H2OProductAvailability extends HTMLElement {
    connectedCallback() {
      this.panel = this.closest('.product__info-container');
      if (!this.panel) return;
      try {
        this.variants = JSON.parse(this.querySelector('script[type="application/json"]')?.textContent || '[]');
      } catch (error) {
        return;
      }
      this.onChange = (event) => {
        const picker = event.target.closest('variant-selects, variant-radios');
        if (picker && !picker.currentVariant) {
          this.panel.removeAttribute('data-h2o-purchasable');
          return;
        }
        this.update();
      };
      this.panel.addEventListener('change', this.onChange);
      this.update();
    }

    disconnectedCallback() {
      this.panel?.removeEventListener('change', this.onChange);
    }

    update() {
      const form = document.getElementById(`product-form-${this.dataset.sectionId}`);
      const input = form?.querySelector('[name="id"]');
      if (!input) return;
      const variant = this.variants.find((item) => String(item.id) === String(input.value));
      this.panel.toggleAttribute('data-h2o-purchasable', variant?.available === true);
    }
  }
  customElements.define('h2o-product-availability', H2OProductAvailability);
}
